/** Do not edit directly **/
/** Do not edit directly **/
/**
 * @prop --sy-text-h1-font-size: Text h 1 font size.
 * @prop --sy-text-h1-text-decoration: Text h 1 text decoration.
 * @prop --sy-text-h1-font-family: Text h 1 font family.
 * @prop --sy-text-h1-font-weight: Text h 1 font weight.
 * @prop --sy-text-h1-font-style: Text h 1 font style.
 * @prop --sy-text-h1-font-stretch: Text h 1 font stretch.
 * @prop --sy-text-h1-letter-spacing: Text h 1 letter spacing.
 * @prop --sy-text-h1-line-height: Text h 1 line height.
 * @prop --sy-text-h2-font-size: Text h 2 font size.
 * @prop --sy-text-h2-text-decoration: Text h 2 text decoration.
 * @prop --sy-text-h2-font-family: Text h 2 font family.
 * @prop --sy-text-h2-font-weight: Text h 2 font weight.
 * @prop --sy-text-h2-font-style: Text h 2 font style.
 * @prop --sy-text-h2-font-stretch: Text h 2 font stretch.
 * @prop --sy-text-h2-letter-spacing: Text h 2 letter spacing.
 * @prop --sy-text-h2-line-height: Text h 2 line height.
 * @prop --sy-text-h3-font-size: Text h 3 font size.
 * @prop --sy-text-h3-text-decoration: Text h 3 text decoration.
 * @prop --sy-text-h3-font-family: Text h 3 font family.
 * @prop --sy-text-h3-font-weight: Text h 3 font weight.
 * @prop --sy-text-h3-font-style: Text h 3 font style.
 * @prop --sy-text-h3-font-stretch: Text h 3 font stretch.
 * @prop --sy-text-h3-letter-spacing: Text h 3 letter spacing.
 * @prop --sy-text-h3-line-height: Text h 3 line height.
 * @prop --sy-text-h4-font-size: Text h 4 font size.
 * @prop --sy-text-h4-text-decoration: Text h 4 text decoration.
 * @prop --sy-text-h4-font-family: Text h 4 font family.
 * @prop --sy-text-h4-font-weight: Text h 4 font weight.
 * @prop --sy-text-h4-font-style: Text h 4 font style.
 * @prop --sy-text-h4-font-stretch: Text h 4 font stretch.
 * @prop --sy-text-h4-letter-spacing: Text h 4 letter spacing.
 * @prop --sy-text-h4-line-height: Text h 4 line height.
 * @prop --sy-text-h5-font-size: Text h 5 font size.
 * @prop --sy-text-h5-text-decoration: Text h 5 text decoration.
 * @prop --sy-text-h5-font-family: Text h 5 font family.
 * @prop --sy-text-h5-font-weight: Text h 5 font weight.
 * @prop --sy-text-h5-font-style: Text h 5 font style.
 * @prop --sy-text-h5-font-stretch: Text h 5 font stretch.
 * @prop --sy-text-h5-letter-spacing: Text h 5 letter spacing.
 * @prop --sy-text-h5-line-height: Text h 5 line height.
 * @prop --sy-text-h6-font-size: Text h 6 font size.
 * @prop --sy-text-h6-text-decoration: Text h 6 text decoration.
 * @prop --sy-text-h6-font-family: Text h 6 font family.
 * @prop --sy-text-h6-font-weight: Text h 6 font weight.
 * @prop --sy-text-h6-font-style: Text h 6 font style.
 * @prop --sy-text-h6-font-stretch: Text h 6 font stretch.
 * @prop --sy-text-h6-letter-spacing: Text h 6 letter spacing.
 * @prop --sy-text-h6-line-height: Text h 6 line height.
 * @prop --sy-text-body-font-size: Text body font size.
 * @prop --sy-text-body-text-decoration: Text body text decoration.
 * @prop --sy-text-body-font-family: Text body font family.
 * @prop --sy-text-body-font-weight: Text body font weight.
 * @prop --sy-text-body-font-style: Text body font style.
 * @prop --sy-text-body-font-stretch: Text body font stretch.
 * @prop --sy-text-body-letter-spacing: Text body letter spacing.
 * @prop --sy-text-body-line-height: Text body line height.
 * @prop --sy-text-small-font-size: Text small font size.
 * @prop --sy-text-small-text-decoration: Text small text decoration.
 * @prop --sy-text-small-font-family: Text small font family.
 * @prop --sy-text-small-font-weight: Text small font weight.
 * @prop --sy-text-small-font-style: Text small font style.
 * @prop --sy-text-small-font-stretch: Text small font stretch.
 * @prop --sy-text-small-letter-spacing: Text small letter spacing.
 * @prop --sy-text-small-line-height: Text small line height.
 * @prop --sy-text-link-font-size: Text link font size.
 * @prop --sy-text-link-text-decoration: Text link text decoration.
 * @prop --sy-text-link-font-family: Text link font family.
 * @prop --sy-text-link-font-weight: Text link font weight.
 * @prop --sy-text-link-font-style: Text link font style.
 * @prop --sy-text-link-font-stretch: Text link font stretch.
 * @prop --sy-text-link-letter-spacing: Text link letter spacing.
 * @prop --sy-text-link-line-height: Text link line height.
 * @prop --sy-text-code-font-size: Text code font size.
 * @prop --sy-text-code-text-decoration: Text code text decoration.
 * @prop --sy-text-code-font-family: Text code font family.
 * @prop --sy-text-code-font-weight: Text code font weight.
 * @prop --sy-text-code-font-style: Text code font style.
 * @prop --sy-text-code-font-stretch: Text code font stretch.
 * @prop --sy-text-code-letter-spacing: Text code letter spacing.
 * @prop --sy-text-code-line-height: Text code line height.
 * @prop --sy-text-lead-font-size: Text lead font size.
 * @prop --sy-text-lead-text-decoration: Text lead text decoration.
 * @prop --sy-text-lead-font-family: Text lead font family.
 * @prop --sy-text-lead-font-weight: Text lead font weight.
 * @prop --sy-text-lead-font-style: Text lead font style.
 * @prop --sy-text-lead-font-stretch: Text lead font stretch.
 * @prop --sy-text-lead-letter-spacing: Text lead letter spacing.
 * @prop --sy-text-lead-line-height: Text lead line height.
 */
*,
:host,
*::before,
*::after {
  box-sizing: border-box;
}

:host([type=h1]) {
  display: block;
  margin-top: 0;
  margin-bottom: 1rem;
}
:host([type=h1]) .sy-text {
  font-size: var(--sy-text-h1-font-size, var(--sy-heading-h1-font-size));
  text-decoration: var(--sy-text-h1-text-decoration, var(--sy-heading-h1-text-decoration));
  font-family: var(--sy-text-h1-font-family, var(--sy-heading-h1-font-family));
  font-weight: var(--sy-text-h1-font-weight, var(--sy-heading-h1-font-weight));
  font-style: var(--sy-text-h1-font-style, var(--sy-heading-h1-font-style));
  font-stretch: var(--sy-text-h1-font-stretch, var(--sy-heading-h1-font-stretch));
  letter-spacing: var(--sy-text-h1-letter-spacing, var(--sy-heading-h1-letter-spacing));
  line-height: var(--sy-text-h1-line-height, var(--sy-heading-h1-line-height));
  margin-top: 0;
  margin-bottom: 0;
}

:host([type=h2]) {
  display: block;
  margin-top: 0;
  margin-bottom: 1rem;
}
:host([type=h2]) .sy-text {
  font-size: var(--sy-text-h2-font-size, var(--sy-heading-h2-font-size));
  text-decoration: var(--sy-text-h2-text-decoration, var(--sy-heading-h2-text-decoration));
  font-family: var(--sy-text-h2-font-family, var(--sy-heading-h2-font-family));
  font-weight: var(--sy-text-h2-font-weight, var(--sy-heading-h2-font-weight));
  font-style: var(--sy-text-h2-font-style, var(--sy-heading-h2-font-style));
  font-stretch: var(--sy-text-h2-font-stretch, var(--sy-heading-h2-font-stretch));
  letter-spacing: var(--sy-text-h2-letter-spacing, var(--sy-heading-h2-letter-spacing));
  line-height: var(--sy-text-h2-line-height, var(--sy-heading-h2-line-height));
  margin-top: 0;
  margin-bottom: 0;
}

:host([type=h3]) {
  display: block;
  margin-top: 0;
  margin-bottom: 1rem;
}
:host([type=h3]) .sy-text {
  font-size: var(--sy-text-h3-font-size, var(--sy-heading-h3-font-size));
  text-decoration: var(--sy-text-h3-text-decoration, var(--sy-heading-h3-text-decoration));
  font-family: var(--sy-text-h3-font-family, var(--sy-heading-h3-font-family));
  font-weight: var(--sy-text-h3-font-weight, var(--sy-heading-h3-font-weight));
  font-style: var(--sy-text-h3-font-style, var(--sy-heading-h3-font-style));
  font-stretch: var(--sy-text-h3-font-stretch, var(--sy-heading-h3-font-stretch));
  letter-spacing: var(--sy-text-h3-letter-spacing, var(--sy-heading-h3-letter-spacing));
  line-height: var(--sy-text-h3-line-height, var(--sy-heading-h3-line-height));
  margin-top: 0;
  margin-bottom: 0;
}

:host([type=h4]) {
  display: block;
  margin-top: 0;
  margin-bottom: 1rem;
}
:host([type=h4]) .sy-text {
  font-size: var(--sy-text-h4-font-size, var(--sy-heading-h4-font-size));
  text-decoration: var(--sy-text-h4-text-decoration, var(--sy-heading-h4-text-decoration));
  font-family: var(--sy-text-h4-font-family, var(--sy-heading-h4-font-family));
  font-weight: var(--sy-text-h4-font-weight, var(--sy-heading-h4-font-weight));
  font-style: var(--sy-text-h4-font-style, var(--sy-heading-h4-font-style));
  font-stretch: var(--sy-text-h4-font-stretch, var(--sy-heading-h4-font-stretch));
  letter-spacing: var(--sy-text-h4-letter-spacing, var(--sy-heading-h4-letter-spacing));
  line-height: var(--sy-text-h4-line-height, var(--sy-heading-h4-line-height));
  margin-top: 0;
  margin-bottom: 0;
}

:host([type=h5]) {
  display: block;
  margin-top: 0;
  margin-bottom: 1rem;
}
:host([type=h5]) .sy-text {
  font-size: var(--sy-text-h5-font-size, var(--sy-heading-h5-font-size));
  text-decoration: var(--sy-text-h5-text-decoration, var(--sy-heading-h5-text-decoration));
  font-family: var(--sy-text-h5-font-family, var(--sy-heading-h5-font-family));
  font-weight: var(--sy-text-h5-font-weight, var(--sy-heading-h5-font-weight));
  font-style: var(--sy-text-h5-font-style, var(--sy-heading-h5-font-style));
  font-stretch: var(--sy-text-h5-font-stretch, var(--sy-heading-h5-font-stretch));
  letter-spacing: var(--sy-text-h5-letter-spacing, var(--sy-heading-h5-letter-spacing));
  line-height: var(--sy-text-h5-line-height, var(--sy-heading-h5-line-height));
  margin-top: 0;
  margin-bottom: 0;
}

:host([type=h6]) {
  display: block;
  margin-top: 0;
  margin-bottom: 1rem;
}
:host([type=h6]) .sy-text {
  font-size: var(--sy-text-h6-font-size, var(--sy-heading-h6-font-size));
  text-decoration: var(--sy-text-h6-text-decoration, var(--sy-heading-h6-text-decoration));
  font-family: var(--sy-text-h6-font-family, var(--sy-heading-h6-font-family));
  font-weight: var(--sy-text-h6-font-weight, var(--sy-heading-h6-font-weight));
  font-style: var(--sy-text-h6-font-style, var(--sy-heading-h6-font-style));
  font-stretch: var(--sy-text-h6-font-stretch, var(--sy-heading-h6-font-stretch));
  letter-spacing: var(--sy-text-h6-letter-spacing, var(--sy-heading-h6-letter-spacing));
  line-height: var(--sy-text-h6-line-height, var(--sy-heading-h6-line-height));
  margin-top: 0;
  margin-bottom: 0;
}

:host([type=body]) .sy-text {
  font-size: var(--sy-text-body-font-size, var(--sy-content-regular-body-font-size));
  text-decoration: var(--sy-text-body-text-decoration, var(--sy-content-regular-body-text-decoration));
  font-family: var(--sy-text-body-font-family, var(--sy-content-regular-body-font-family));
  font-weight: var(--sy-text-body-font-weight, var(--sy-content-regular-body-font-weight));
  font-style: var(--sy-text-body-font-style, var(--sy-content-regular-body-font-style));
  font-stretch: var(--sy-text-body-font-stretch, var(--sy-content-regular-body-font-stretch));
  letter-spacing: var(--sy-text-body-letter-spacing, var(--sy-content-regular-body-letter-spacing));
  line-height: var(--sy-text-body-line-height, var(--sy-content-regular-body-line-height));
  margin-top: 0;
  margin-bottom: 0;
}

:host([type=small]) .sy-text {
  font-size: var(--sy-text-small-font-size, var(--sy-content-regular-small-font-size));
  text-decoration: var(--sy-text-small-text-decoration, var(--sy-content-regular-small-text-decoration));
  font-family: var(--sy-text-small-font-family, var(--sy-content-regular-small-font-family));
  font-weight: var(--sy-text-small-font-weight, var(--sy-content-regular-small-font-weight));
  font-style: var(--sy-text-small-font-style, var(--sy-content-regular-small-font-style));
  font-stretch: var(--sy-text-small-font-stretch, var(--sy-content-regular-small-font-stretch));
  letter-spacing: var(--sy-text-small-letter-spacing, var(--sy-content-regular-small-letter-spacing));
  line-height: var(--sy-text-small-line-height, var(--sy-content-regular-small-line-height));
  margin-top: 0;
  margin-bottom: 0;
}

:host([type=code]) {
  display: block;
  margin-top: 0;
  margin-bottom: 1rem;
}
:host([type=code]) pre {
  overflow: auto;
}
:host([type=code]) .sy-text {
  font-size: var(--sy-text-code-font-size, var(--sy-content-regular-code-font-size));
  text-decoration: var(--sy-text-code-text-decoration, var(--sy-content-regular-code-text-decoration));
  font-family: var(--sy-text-code-font-family, var(--sy-content-regular-code-font-family));
  font-weight: var(--sy-text-code-font-weight, var(--sy-content-regular-code-font-weight));
  font-style: var(--sy-text-code-font-style, var(--sy-content-regular-code-font-style));
  font-stretch: var(--sy-text-code-font-stretch, var(--sy-content-regular-code-font-stretch));
  letter-spacing: var(--sy-text-code-letter-spacing, var(--sy-content-regular-code-letter-spacing));
  line-height: var(--sy-text-code-line-height, var(--sy-content-regular-code-line-height));
  margin-top: 0;
  margin-bottom: 0;
}

:host([type=lead]) {
  display: block;
  margin-top: 0;
  margin-bottom: 1rem;
}
:host([type=lead]) .sy-text {
  font-size: var(--sy-text-lead-font-size, var(--sy-content-regular-lead-font-size));
  text-decoration: var(--sy-text-lead-text-decoration, var(--sy-content-regular-lead-text-decoration));
  font-family: var(--sy-text-lead-font-family, var(--sy-content-regular-lead-font-family));
  font-weight: var(--sy-text-lead-font-weight, var(--sy-content-regular-lead-font-weight));
  font-style: var(--sy-text-lead-font-style, var(--sy-content-regular-lead-font-style));
  font-stretch: var(--sy-text-lead-font-stretch, var(--sy-content-regular-lead-font-stretch));
  letter-spacing: var(--sy-text-lead-letter-spacing, var(--sy-content-regular-lead-letter-spacing));
  line-height: var(--sy-text-lead-line-height, var(--sy-content-regular-lead-line-height));
  margin-top: 0;
  margin-bottom: 0;
}